import { call, put, takeLatest } from 'redux-saga/effects'
import * as R from 'ramda'
import * as actions from '../actions/party'
import { request, requestWithAuth, processErr } from '../api/request'
import {
    GET_PARTY_REQUEST,
    PARTY_LOGIN_REQUEST,
    PARTY_LOGIN_DIRECTLY_REQUEST,
    CHECK_JOINED_REQUEST,
    GET_RECORDS_REQUEST,
    UPLOAD_RECORD_REQUEST,
    GET_LEADERBOARD_REQUEST,
    GET_PARTY_RECORD_REQUEST,
    SYNC_PROFILE_REQUEST,
} from '../constant/actionTypes'

const url = '/party'
const urlRecord = '/record'

const getPartyApi = (payload) => {
    return request().get(`${url}/target?partyId=${payload}`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const partyLoginApi = (payload) => {
    return requestWithAuth().post(`${url}/user/joinWithVerify`, payload)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const partyLoginDirectlyApi = (payload) => {
    return requestWithAuth().post(`${url}/user/join`, payload)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const checkJoinedApi = (payload) => {
    return requestWithAuth().get(`${url}/user/checkJoined?partyId=${payload}`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const getRecordsApi = (payload) => {
    return requestWithAuth().get(`${urlRecord}/sport/list?type=${payload}&withMeta=0`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const uploadRecordApi = (payload) => {
    return requestWithAuth().post(`${url}/user/updateWithRecord`, payload)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const getLeaderboardApi = payload => {
    const { partyId, page } = payload

    return request().get(`${url}/user/leaderBoard?partyId=${partyId}&size=10&page=${page}`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const getPartyRecordApi = payload => {

    return requestWithAuth().get(`${url}/user/record?partyId=${payload}`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                    hasUploaded: !R.or(R.isNil(res.data.distance), R.isNil(res.data.duration))
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

const syncProfileApi = () => {

    return requestWithAuth().post(`${url}/user/syncProfile`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                }
            }
        })
        .catch(err => { throw processErr(err) })
}

function* getPartyRequest(action) {
    try {
        const data = yield call(getPartyApi, action.payload)
        yield put(actions.getPartySuccess(data))
    } catch (e) {
        yield put(actions.getPartyFailure(e))
    }
}


function* partyLoginRequest(action) {
    try {
        const data = yield call(partyLoginApi, action.payload)
        yield put(actions.partyLoginSuccess(data))
    } catch (e) {
        yield put(actions.partyLoginFailure(e))
    }
}

function* partyLoginDirectlyRequest(action) {
    try {
        const data = yield call(partyLoginDirectlyApi, action.payload)
        yield put(actions.partyLoginDirectlySuccess(data))
    } catch (e) {
        yield put(actions.partyLoginDirectlyFailure(e))
    }
}

function* checkJoinedRequest(action) {
    try {
        const data = yield call(checkJoinedApi, action.payload)
        yield put(actions.checkJoinedSuccess(data))
    } catch (e) {
        yield put(actions.checkJoinedFailure(e))
    }
}

function* getRecordsRequest(action) {
    try {
        const data = yield call(getRecordsApi, action.payload)
        yield put(actions.getRecordsSuccess(data))
    } catch (e) {
        yield put(actions.getRecordsFailure(e))
    }
}

function* uploadRecordRequest(action) {
    try {
        const data = yield call(uploadRecordApi, action.payload)
        yield put(actions.uploadRecordSuccess(data))
    } catch (e) {
        yield put(actions.uploadRecordFailure(e))
    }
}

function* getLeaderboardRequest(action) {
    try {
        const data = yield call(getLeaderboardApi, action.payload)
        yield put(actions.getLeaderboardSuccess(data))
    } catch (e) {
        yield put(actions.getLeaderboardFailure(e))
    }
}

function* getPartyRecordRequest(action) {
    try {
        const data = yield call(getPartyRecordApi, action.payload)
        yield put(actions.getPartyRecordSuccess(data))
    } catch (e) {
        yield put(actions.getPartyRecordFailure(e))
    }
}

function* syncProfileRequest(action) {
    try {
        const data = yield call(syncProfileApi, action.payload)
        yield put(actions.syncProfileSuccess(data))
    } catch (e) {
        yield put(actions.syncProfileFailure(e))
    }
}


const party = [
    takeLatest(GET_PARTY_REQUEST, getPartyRequest),
    takeLatest(PARTY_LOGIN_REQUEST, partyLoginRequest),
    takeLatest(PARTY_LOGIN_DIRECTLY_REQUEST, partyLoginDirectlyRequest),
    takeLatest(CHECK_JOINED_REQUEST, checkJoinedRequest),
    takeLatest(GET_RECORDS_REQUEST, getRecordsRequest),
    takeLatest(UPLOAD_RECORD_REQUEST, uploadRecordRequest),
    takeLatest(GET_LEADERBOARD_REQUEST, getLeaderboardRequest),
    takeLatest(GET_PARTY_RECORD_REQUEST, getPartyRecordRequest),
    takeLatest(SYNC_PROFILE_REQUEST, syncProfileRequest),
]

export default party